import React, {PropTypes} from 'react';
import ScreenComponents from './ScreenComponents/';
import Consts from '../Consts';

class Screen extends React.Component {
    constructor(props) {
        super(props);
        this.ScreenComponents = Object.assign(ScreenComponents, props.additionalScreens);      
    }   
    

    render() {
        let component = {};

        if(this.props.name){
            component = ScreenComponents[this.props.name];
            if(component){
                return React.createElement(component, this.props);
            }else{
                return React.createElement(ScreenComponents['Error'], Consts.defaultErrorScreenData);
            }
        }

        return (<div>
                    <div className="o-PageContainer--spinner">
                        <img src={Consts.baseDir+"/images/spinner.gif"} />
                    </div>
                </div>);
    }
}

Screen.propTypes = {
    name: React.PropTypes.string.isRequired,
    values: React.PropTypes.object.isRequired,
    uiSpec: React.PropTypes.object.isRequired,
    textResources: React.PropTypes.object.isRequired,
    additionalScreens: React.PropTypes.object
};

export default Screen;


/** WEBPACK FOOTER **
 ** ./src/components/Screen.js
 **/